import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UtilService } from './util.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private util: UtilService, private router: Router) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const isAuth = this.util.isUserLoggedIn;
    
    if(!isAuth &&route.routeConfig?.path === '' ){
      return true;
    }else if(route.routeConfig?.path === ''){
      
      this.util.route(sessionStorage.getItem('route'));
    }
    if(isAuth && (route.routeConfig?.path === 'emailVerification' || route.routeConfig?.path === 'home') ){
      return true;
    }
    if (!isAuth) {
      if(route.routeConfig?.path === 'login'){
     
      }else
      this.util.route('main');
    }else if(this.util.getCache('userInfo') && !this.util.getCache('userInfo').userInfo.email){
      this.util.route('emailVerification');
    }
    return isAuth || route.routeConfig?.path === 'login';
  }
}
